import { MinusOutlined } from "@ant-design/icons";
import { Input, Tooltip, theme } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import "./chatbox.css";
import { FloatButton } from "antd/lib";
import axios from "axios";
import { TbBulb, TbMessageChatbot } from "react-icons/tb";
import { FiUser } from "react-icons/fi";
import { LuSendHorizontal } from "react-icons/lu";
import { IoCloseOutline } from "react-icons/io5";
import { FaStar, FaRegStar } from "react-icons/fa";
import {
    MdOutlineThumbUp,
    MdOutlineThumbDown,
    MdThumbUpAlt,
    MdThumbDownAlt,
    MdOutlineZoomOutMap,
    MdOutlineZoomInMap,
} from "react-icons/md";
import ChatBotService from "../../service/ChatBotService";
import { SettingContext } from "../../routes";

const boatAxios = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 1000 * 60,
});

const getReviewTitle = (rating) => {
    if (rating) {
        switch (rating) {
            case 1:
                return `Very Unsatisfied`;
            case 2:
                return `Unsatisfied`;
            case 3:
                return `Neutral`;
            case 4:
                return `Satisfied`;
            case 5:
                return `Very Satisfied`;
            default:
                return `Very Unsatisfied`;
        }
    }
};

const ChatBox = (props) => {
    const { token } = theme.useToken();
    const { selectedHotels } = useContext(SettingContext);
    const { hotel } = { hotel: "sample hotel data" }; // Replace with actual hotel data from globals or context

    const [visible, setVisible] = useState(false);
    const [newMessage, setNewMessage] = useState("");
    const [chatBotHeight, setchatBotHeight] = useState(0);
    const [isUnreadMessage, setIsUnreadMessage] = useState(false);
    const [chatMessages, setChatMessages] = useState([]);
    const [isActiveChat, setIsActiveChat] = useState(true);
    const [userRating, setUserRating] = useState(0);
    const [isTipsVisible, setIsTipsVisible] = useState(false);

    const chatEndRef = useRef(null);
    const showDrawer = () => {
        setIsUnreadMessage(false);
        setVisible(true);
    };

    const closeDrawer = () => {
        setVisible(false);
        if (!isActiveChat) clearChatVariable();
    };

    const handleSendMessage = () => {
        if (!newMessage.trim()) return;
        let question = newMessage;
        const UUID = new Date().getTime();
        let tempChatMsg = [
            ...chatMessages,
            { msg: newMessage, from: 0, question_id: UUID },
        ];
        setChatMessages([
            ...chatMessages,
            { msg: newMessage, from: 0, question_id: UUID },
        ]);
        setNewMessage("");

        boatAxios("/ask", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                query: question,
                question: question,
                hotel_ids: selectedHotels || [1573],
            },
            timeout: 1000 * 60,
        })
            .then((res) => res?.data)
            .then((res) => {
                console.log("[ask] --> Response from AI : ", res);
                setChatMessages([
                    ...tempChatMsg,
                    {
                        msg:
                            res?.Success != 0
                                ? res?.response || res?.data?.answer
                                : res?.error,
                        from: 1,
                        answer_id: UUID,
                    },
                ]);
                if (!visible) setIsUnreadMessage(true);
            })
            .catch((e) => {
                console.log(e);
                setChatMessages([
                    ...tempChatMsg,
                    {
                        msg: "It looks like there's an issue retrieving that information at the moment. Please try again in a moment, or let me know if you need assistance with something else.",
                        from: 1,
                    },
                ]);
            });
    };

    // const handleSendMessage = () => {
    //     if (!newMessage.trim()) return;
    //     let question = newMessage;
    //     const UUID = new Date().getTime();
    //     let tempChatMsg = [
    //         ...chatMessages,
    //         { msg: newMessage, from: 0, question_id: UUID },
    //     ];
    //     setChatMessages([
    //         ...chatMessages,
    //         { msg: newMessage, from: 0, question_id: UUID },
    //     ]);
    //     console.log("question", question);
    //     setNewMessage("");
    //     var bodyFormData = new FormData();
    //     bodyFormData.append("query", question);
    //     bodyFormData.append("questions", question);
    //     bodyFormData.append("hotel_ids", [1573]);
    //     boatAxios("/ask", {
    //         method: "POST",
    //         data: bodyFormData,
    //         timeout: 1000 * 60,
    //     })
    //         .then((res) => res?.data)
    //         .then((res) => {
    //             console.log("[ask] --> Response from AI : ", res);

    //             // setChatMessages([
    //             //     ...tempChatMsg,
    //             //     {
    //             //         msg: res?.Success != 0 ? res?.response : res?.error,
    //             //         from: 1,
    //             //         answer_id: UUID,
    //             //     },
    //             // ]);
    //             if (!visible) setIsUnreadMessage(true);
    //         })
    //         .catch((e) => {
    //             console.log(e);
    //             setChatMessages([
    //                 ...tempChatMsg,
    //                 {
    //                     msg: "It looks like there’s an issue retrieving that information at the moment. Please try again in a moment, or let me know if you need assistance with something else.",
    //                     from: 1,
    //                 },
    //             ]);
    //         });
    // };

    const changeChatBoxSize = () => {
        setchatBotHeight(chatBotHeight == 0 ? 1 : 0);
    };

    const handleChatEnd = () => {
        isActiveChat && setIsActiveChat(false);
    };

    const clearChatVariable = () => {
        setVisible(false);
        setNewMessage("");
        setchatBotHeight(0);
        setIsUnreadMessage(false);
        setChatMessages([]);
        setIsActiveChat(true);
        setUserRating(0);
    };

    const submitRating = async (reviews) => {
        setUserRating(reviews);
        ChatBotService.addChatbotReviews({
            reviews: reviews,
            staff_id: localStorage.getItem("x-dashboard-staffid"),
        });
    };

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "end",
        });
    }, [chatMessages, isActiveChat, userRating]);

    const submitAnsRating = (query, answer, flag, uuID, answerIndex) => {
        var bodyFormData = new FormData();
        bodyFormData.append("answer", answer);
        bodyFormData.append("flag", flag);
        bodyFormData.append("query", query);
        bodyFormData.append("uuID", uuID);
        boatAxios("/flag", {
            method: "POST",
            data: bodyFormData,
        });
        const chatMsgAry = [...chatMessages];
        chatMsgAry.splice(answerIndex, 1, {
            ...chatMessages[answerIndex],
            rating: flag,
        });
        setChatMessages(chatMsgAry);
    };

    return (
        <>
            {!visible && (
                <div className="chatbox">
                    <FloatButton
                        type="primary"
                        // backgroundColor="#7c3aed"
                        style={{ backgroundColor: token.colorPrimary }}
                        onClick={showDrawer}
                        icon={
                            <TbMessageChatbot
                                style={{
                                    color: "#ffffff",
                                    backgroundColor: token.colorPrimary,
                                }}
                            />
                        }
                        badge={{ dot: isUnreadMessage, color: "green" }}
                    />
                </div>
            )}
            {visible && (
                <div
                    className={`chatbox-main  ${
                        chatBotHeight == 0
                            ? "chatBox-main-sm"
                            : "chatBox-main-lg"
                    }`}
                >
                    <div className="chatbox-main-header">
                        <div className="chatbox-main-header-left">
                            <TbMessageChatbot
                                style={{
                                    height: "20px",
                                    width: "20px",
                                    color: token.colorPrimary,
                                }}
                            />
                            <strong>InnSight - Your Property Assistant</strong>
                        </div>

                        <div className="chatbox-main-header-right">
                            {chatBotHeight == 0 ? (
                                <MdOutlineZoomOutMap
                                    onClick={changeChatBoxSize}
                                    style={{ cursor: "pointer" }}
                                />
                            ) : (
                                <MdOutlineZoomInMap
                                    onClick={changeChatBoxSize}
                                    style={{ cursor: "pointer" }}
                                />
                            )}
                            <MinusOutlined onClick={closeDrawer} />
                        </div>
                    </div>
                    <div className="chatbox-main-content">
                        <div className="message-left-div">
                            <div className="message-icon-div">
                                <TbMessageChatbot />
                            </div>
                            <div className="message message-left">
                                <span>
                                    Hello👋 I’m InnSight, your property
                                    assistant. How can I assist you ?
                                </span>
                            </div>
                        </div>
                        {chatMessages.length > 0 && (
                            <div ref={chatEndRef}>
                                {chatMessages.map((m, i) => (
                                    <>
                                        {m.from == 0 ? (
                                            <div className="message-right-div">
                                                <div className="message message-right">
                                                    <span>{m?.msg}</span>
                                                </div>
                                                <div className="message-icon-div">
                                                    <FiUser />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="message-left-div">
                                                <div className="message-icon-div">
                                                    <TbMessageChatbot />
                                                </div>
                                                <div className="message message-left">
                                                    <span>{m?.msg}</span>
                                                    <div
                                                        style={{
                                                            marginRight: "auto",
                                                        }}
                                                    >
                                                        {m.rating ? (
                                                            <>
                                                                {m.rating ===
                                                                "good" ? (
                                                                    <>
                                                                        <MdThumbUpAlt
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                fontSize:
                                                                                    "12px",
                                                                            }}
                                                                        />
                                                                        <MdOutlineThumbDown
                                                                            style={{
                                                                                fontSize:
                                                                                    "12px",
                                                                                marginLeft:
                                                                                    "5px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                            onClick={() => {
                                                                                submitAnsRating(
                                                                                    chatMessages[
                                                                                        i -
                                                                                            1
                                                                                    ]
                                                                                        .msg,
                                                                                    m?.msg,
                                                                                    "bad",
                                                                                    m?.answer_id,
                                                                                    i,
                                                                                );
                                                                            }}
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <MdOutlineThumbUp
                                                                            style={{
                                                                                fontSize:
                                                                                    "12px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                            onClick={() => {
                                                                                submitAnsRating(
                                                                                    chatMessages[
                                                                                        i -
                                                                                            1
                                                                                    ]
                                                                                        .msg,
                                                                                    m?.msg,
                                                                                    "good",
                                                                                    m?.answer_id,
                                                                                    i,
                                                                                );
                                                                            }}
                                                                        />
                                                                        <MdThumbDownAlt
                                                                            style={{
                                                                                fontSize:
                                                                                    "12px",
                                                                                marginLeft:
                                                                                    "5px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />
                                                                    </>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <MdOutlineThumbUp
                                                                    style={{
                                                                        fontSize:
                                                                            "12px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() => {
                                                                        submitAnsRating(
                                                                            chatMessages[
                                                                                i -
                                                                                    1
                                                                            ]
                                                                                .msg,
                                                                            m?.msg,
                                                                            "good",
                                                                            m?.answer_id,
                                                                            i,
                                                                        );
                                                                    }}
                                                                />
                                                                <MdOutlineThumbDown
                                                                    style={{
                                                                        fontSize:
                                                                            "12px",
                                                                        marginLeft:
                                                                            "5px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() => {
                                                                        submitAnsRating(
                                                                            chatMessages[
                                                                                i -
                                                                                    1
                                                                            ]
                                                                                .msg,
                                                                            m?.msg,
                                                                            "bad",
                                                                            m?.answer_id,
                                                                            i,
                                                                        );
                                                                    }}
                                                                />
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                ))}
                                <>
                                    <span
                                        className="end-chat-button"
                                        onClick={handleChatEnd}
                                    >
                                        {isActiveChat ? (
                                            chatMessages[
                                                chatMessages.length - 1
                                            ].from == 1 ? (
                                                <span
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    End Chat
                                                </span>
                                            ) : (
                                                ``
                                            )
                                        ) : (
                                            `Chat Ended`
                                        )}
                                    </span>
                                    {!isActiveChat && (
                                        <div className="chat-feedback-main">
                                            <span className="feedback-text">
                                                I hope, I was able to help!
                                                Would you mind leaving a quick
                                                review? Your feedback helps me
                                                to improve!
                                            </span>
                                            <div className="feedback-rating">
                                                {[1, 2, 3, 4, 5].map((i) => (
                                                    <Tooltip
                                                        key={i}
                                                        title={getReviewTitle(
                                                            i,
                                                        )}
                                                        color={"#ff9007"}
                                                        fontSize="10px"
                                                    >
                                                        {i <= userRating ? (
                                                            <FaStar
                                                                color={
                                                                    token.colorPrimary
                                                                }
                                                                onClick={() =>
                                                                    submitRating(
                                                                        i,
                                                                    )
                                                                }
                                                                style={{
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        ) : (
                                                            <FaRegStar
                                                                onClick={() =>
                                                                    submitRating(
                                                                        i,
                                                                    )
                                                                }
                                                                style={{
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        )}
                                                    </Tooltip>
                                                ))}
                                            </div>
                                            {userRating ? (
                                                <strong className="feedback-text">
                                                    Thank you for your feedback!
                                                </strong>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    )}
                                </>
                            </div>
                        )}
                    </div>
                    {isTipsVisible ? (
                        <div
                            style={{
                                border: `1px solid ${token.colorBorder}`,
                                borderRadius: "5px",
                                margin: "auto 10px 0px 10px",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <TbBulb
                                        size={"20px"}
                                        style={{
                                            margin: "6px",
                                            color: token.colorPrimary,
                                        }}
                                    />
                                    <span
                                        style={{
                                            color: token.colorPrimary,
                                            fontSize: "x-small",
                                        }}
                                    >
                                        Tips
                                    </span>
                                </div>
                                <IoCloseOutline
                                    style={{
                                        margin: "6px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        setIsTipsVisible(false);
                                    }}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    margin: "0 10px 5px 35px",
                                    fontSize: "xx-small",
                                }}
                            >
                                <span>
                                    <strong>Be Specific: </strong>The more
                                    details you provide, the better I can help.
                                </span>
                                <span>
                                    <strong>Mistakes Happen: </strong>I might
                                    not always get it right, but I’ll do my
                                    best. Just ask again if needed!
                                </span>
                                <span>
                                    <strong>Keep It Short: </strong>Clear and
                                    concise messages help me respond faster.
                                </span>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                    {isActiveChat && (
                        <div
                            className="chatbox-main-footer"
                            style={{
                                marginTop: isTipsVisible ? "0" : "auto",
                            }}
                        >
                            <Input
                                value={newMessage}
                                onChange={(e) => setNewMessage(e.target.value)}
                                onPressEnter={handleSendMessage}
                                placeholder="Write a message..."
                                suffix={
                                    <LuSendHorizontal
                                        style={{
                                            fontSize: "16px",
                                            color: token.colorPrimary,
                                            cursor: "pointer",
                                        }}
                                        onClick={handleSendMessage}
                                    />
                                }
                            />

                            <div
                                style={{
                                    border: `1px solid ${token.colorBorder}`,
                                    background: "inherit",
                                    borderRadius: "5px",
                                    display: "flex",
                                    alignContent: "center",
                                }}
                                onClick={() => {
                                    setIsTipsVisible(!isTipsVisible);
                                }}
                            >
                                <TbBulb
                                    size={"18px"}
                                    style={{
                                        margin: "5px",
                                        cursor: "pointer",
                                        color: token.colorPrimary,
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
export default ChatBox;
